module.exports = __webpack_public_path__ + "img/xq.1e0be148.jpg";